'use client';

import classnames from 'classnames';

import type { AccordionProps } from './Accordion.types';
import { AccordionItem } from './layout/AccordionItem';

import styles from './Accordion.module.scss';

function Accordion({
  style,
  className,
  items,
  testId = 'ui-accordion',
}: AccordionProps) {
  return (
    <div
      style={style}
      className={classnames(styles['accordion'], className)}
      data-testid={testId}
    >
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          item={item}
          data-testid={`${testId}_item-${index}`}
        />
      ))}
    </div>
  );
}

export { Accordion };
